import React from 'react';
import { Link } from 'react-router-dom';
import { LuCheck } from 'react-icons/lu';
import { PLANS, PLAN_FEATURE_ROWS, planCellValue } from '../../config/plans';

export default function ProductPlanFeaturesSection() {
  return (
    <section className="product-features-band" aria-labelledby="product-features-heading">
      <div className="product-features-head">
        <h2 id="product-features-heading" className="product-section-title">
          Everything you get — by plan
        </h2>
        <p className="product-section-lead product-features-lead">
          Same feature list we show on{' '}
          <Link to="/pricing">Pricing</Link>. Free is fully usable; Pro and Team add AI, sharing, and
          collaboration.
        </p>
      </div>

      <ul className="product-plan-feature-grid">
        {PLANS.map((plan) => (
          <li
            key={plan.id}
            className={`product-plan-feature-card${plan.highlight ? ' product-plan-feature-card--highlight' : ''}`}
          >
            <div className="product-plan-feature-card-head">
              <h3 className="product-plan-feature-name">{plan.name}</h3>
              <p className="product-plan-feature-tagline">{plan.tagline}</p>
              {plan.monthly > 0 ? (
                <p className="product-plan-feature-price">
                  From ${plan.monthly}/mo
                  {plan.yearly ? ` · $${plan.yearly}/yr` : ''}
                </p>
              ) : (
                <p className="product-plan-feature-price product-plan-feature-price--free">$0 — no card required</p>
              )}
            </div>
            <ul className="product-plan-feature-list">
              {plan.features.map((feature) => (
                <li key={feature}>
                  <LuCheck className="product-plan-feature-check" aria-hidden />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>

      <div className="product-features-table-block">
        <h3 className="product-features-table-title">Feature comparison</h3>
        <p className="product-features-table-lead">
          ✓ included · — not on this plan · text values show limits or tiers
        </p>
        <div className="product-features-table-wrap">
          <table className="product-features-table">
            <thead>
              <tr>
                <th scope="col">Feature</th>
                <th scope="col">Free</th>
                <th scope="col">Pro</th>
                <th scope="col">Team</th>
              </tr>
            </thead>
            <tbody>
              {PLAN_FEATURE_ROWS.map((row) => (
                <tr key={row.label}>
                  <th scope="row">{row.label}</th>
                  <td>{planCellValue(row.free)}</td>
                  <td>{planCellValue(row.pro)}</td>
                  <td>{planCellValue(row.team)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="product-features-foot">
          <Link to="/pricing" className="product-pricing-link">
            See pricing &amp; checkout
          </Link>
          {' · '}
          <Link to="/features">Full product tour</Link>
        </p>
      </div>
    </section>
  );
}
